/**for rebuild the app */
/** Below are the variables used as constants */
/** for rebuild the app */
import { environment } from '../../../environments/environment';
export let sectionsArr = [];
declare var require: any;
export const HideRestrictedComponents: any = [
  'plan',
  'dashboard',
  'resumeResume',
  'resumeCoverLetter',
  'cpCoursePlan',
  'sortCPST',
  'sortCivilTests',
  'sortAcadTests2',
  'sortAcadTests1',
];
export const questionsArr = [
  { section: 'CareerGoals', questions: ['What are your career goals?'] },
  {
    section: 'EducationPlans', questions: ['What are your educational plans after high school?',
      'What other educational plans do you have?']
  },
  { section: 'CareerCluster', questions: ['What career clusters interest you?'] },
  { section: 'GraduationRequirements', questions: ['Enter your planned and completed credits.'] },
  { section: 'TestScores', questions: ['Enter up to 6 test names with test scores.'] },
  { section: 'ActionPlan', questions: ['What is your action plan for this year?'] },
  { section: 'SupportNetwork', questions: ['Who will encourage and support you to achieve your goals?'] }
];


export const educationFieldsArr = [
  { label: `Bachelor's degree (4 years)`, value: 'BD', selected: false },
  { label: 'Associate degree (2 years)', value: 'AD', selected: false },
  { label: 'Certificate', value: 'Cer', selected: false },
  { label: 'Apprenticeship', value: 'App', selected: false },
  { label: 'Military', value: 'Mil', selected: false },
  { label: 'Employment', value: 'Emp', selected: false },
  { label: 'No plan at this time', value: 'None', selected: false },
  { label: 'Other', value: 'other', selected: false }
];

export const EndUrlArr = [
  { section: 'NewPassword', endUrl: 'PasswordReset', tokenUrl: 'PasswordResetTokenValid' },
  { section: 'UsernameRecovery', endUrl: 'UsernameRecovery' },
  { section: 'PasswordRecovery', endUrl: 'PasswordResetSendEmail' },
  { section: 'PersonalInfo', endUrl: 'Account' },
  { section: 'CareerGoals', endUrl: 'Reflection', fieldName: 'CareerGoals' },
  { section: 'EducationPlans', endUrl: 'Reflection', fieldNameCheck: 'PSPlansList', fieldNameRef: 'PSPlans' },
  { section: 'CareerAssessments', endUrl: 'SavedAnswers', fieldName: '' },
  { section: 'CareerCluster', endUrl: 'Reflection', fieldName: 'CareerFields', secondRef: 'OccClusters' },
  { section: 'OccAndCluster', endUrl: 'SavedFiles', fileName: 'Occ' },
  { section: 'CoursePlan', endUrl: 'CoursePlan' },
  { section: 'GraduationRequirements', endUrl: 'GraduationRequirements' },
  { section: 'TestScores', endUrl: 'TestScores' },
  { section: 'StudyOfInterest', endUrl: 'SavedFiles', fileName: 'Prog' },
  { section: 'SchoolsOfInterest', endUrl: 'SavedFiles', fileName: 'NSch' },
  { section: 'VolunteerCommunityService', endUrl: 'VolunteerExperiences' },
  { section: 'ExtraActivities', endUrl: 'Extracurricular' },
  { section: 'EmploymentHistory', endUrl: 'Employment' },
  { section: 'ActionPlan', endUrl: 'Reflection', fieldName: 'ActionPlan' },
  { section: 'SupportNetwork', endUrl: 'Reflection', fieldName: 'Network' },
  { section: 'ExperientialLearning', endUrl: 'ExperientialLearning' },
  { section: 'CommentsAndSignature', endUrl: 'CommentsAndSig' }
];

export const returnUrl = {
  url: window.location.protocol + '//' + window.location.host + '/login/newPassword'
};

export const tableNoData = [
  {
    section: ['CareerAssessments', 'OccAndCluster', 'CoursePlan', 'StudyOfInterest', 'SchoolsOfInterest',
      'ExtraActivities', 'EmploymentHistory', 'VolunteerCommunityService'],
    text: 'No information has been entered for this item.'
  }
];

export const ExperientialLearningArr = [
  {
    name: 'Expert Presenters', subName: 'ELExpert', subNameList: 'ELExpertList',
    Myself: false, Careers: false, Future: false, Try: false,
    hoverText: `Expert Presenters visit classrooms and share information about their careers, educational background and personal choices that helped them achieve their career success.`
  },
  {
    name: 'Tours and Field Trips', subName: 'ELTour', subNameList: 'ELTourList',
    Myself: false, Careers: false, Future: false, Try: false,
    hoverText: `Tours and Field Tripshelp students explore the knowledge and skills of different occupations within an industry cluster.`
  },
  {
    name: 'Entrepreneurship', subName: 'ELEpren', subNameList: 'ELEprenList',
    Myself: false, Careers: false, Future: false, Try: false,
    hoverText: 'Entrepreneurship provides students with opportunities to demonstrate leadership and to learn about organizing and operating their own businesses or projects.'
  },
  {
    name: 'Community Based Learning', subName: 'ELCBLearn', subNameList: 'ELCBLearnList',
    Myself: false, Careers: false, Future: false, Try: false,
    hoverText: 'Community-Based Learningexperiences are activities such as job shadowing, work site visits or field trips, work in a business, participation in a club or organization or work in a school based enterprise.'
  },
  {
    name: 'Work-based Learning', subName: 'ELWBLearn', subNameList: 'ELWBLearnList',
    Myself: false, Careers: false, Future: false, Try: false,
    hoverText: 'Work-Based Learning occurs outside of the classroom. It involves learning experiences and activities that include paid or unpaid work experience such as structured cooperative work experiences, internships, and youth apprenticeship.'
  },
  {
    name: 'Job Shadowing', subName: 'ELShadow', subNameList: 'ELShadowList',
    Myself: false, Careers: false, Future: false, Try: false,
    hoverText: 'Job Shadowing is a short-term experience intended to help students explore a range of career objectives.  Students make brief worksite visits to spend time with individual workers learning what knowledge, skills and education their jobs entail.'
  },
  {
    name: 'Service Learning', subName: 'ELService', subNameList: 'ELServiceList',
    Myself: false, Careers: false, Future: false, Try: false,
    hoverText: 'Service Learning is a way of teaching and learning that engages all learners in hands-on projects in the community to meet learning objectives. This type of learning benefits students and strengthens communities.'
  },
  {
    name: 'Internships', subName: 'ELIntern', subNameList: 'ELInternList',
    Myself: false, Careers: false, Future: false, Try: false,
    hoverText: 'Internships are short term work experiences but can last 40 hours or more. Interns work in professional settings under the supervision of professionals. In high school, internships must be supervised by a licensed work-based learning teacher.'
  },
  {
    name: 'Cooperative Education', subName: 'ELCoopEd', subNameList: 'ELCoopEdList',
    Myself: false, Careers: false, Future: false, Try: false,
    hoverText: 'Cooperative Work Experience provides students with work experiences related to their major, career field or pathway goal. Students are involved in classroom study and discipline-related employment in order to gain career related work experience before graduating.'
  },
  {
    name: 'Mentoring / eMentoring', subName: 'ELMentor', subNameList: 'ELMentorList',
    Myself: false, Careers: false, Future: false, Try: false,
    hoverText: 'Mentoring / eMentoring is a professional relationship in which an experienced person (mentor) assists another (mentee) in developing skills and knowledge that will enhance the mentee’s professional and personal growth.'
  },
  {
    name: 'Youth Apprenticeship', subName: 'ELPreApp', subNameList: 'ELPreAppList',
    Myself: false, Careers: false, Future: false, Try: false,
    hoverText: 'Youth Apprenticeship’s are paid experiences for 11th and 12th grade students. Youth Apprenticeship students must be supervised by a licensed work-based learning teacher in a state approved program. This type of apprenticeship requires a written agreement by all parties and a training plan.'
  },
  {
    name: 'Pre-Apprenticeship', subName: 'ELYouthApp', subNameList: 'ELYouthAppList',
    Myself: false, Careers: false, Future: false, Try: false,
    hoverText: 'Pre-Apprenticeship programs help prepare students to enter and succeed in a Registered Apprenticeship program.'
  }
];


export const successMessageArr = [
  {
    section: ['CareerGoals', 'EducationPlans', 'CareerCluster'
      , 'ActionPlan', 'SupportNetwork', 'ExperientialLearning', 'PersonalInfo', 'TestScores', 'CommentsAndSignature'
    ], save: 'Your data has been successfully saved.', update: 'Data has been successfully updated', error: 'Saving failed.'
  },
];

export const routeConstants = [
  {
    module: 'plp', baseUrl: 'login', allowedRoutes: ['plpcontent']
  },
  {
    module: 'occsort', baseUrl: 'os', allowedRoutes: ['os', 'occsort']
  },
  {
    module: 'interestprofilersf', baseUrl: 'ip', allowedRoutes: ['ip', 'interestprofilersf']
  },
  {
    module: 'entrepreneurquiz', baseUrl: 'eq', allowedRoutes: ['eq', 'entrepreneurquiz']
  },
  {
    module: 'all', baseUrl: 'login',
    allowedRoutes: ['plpcontent', 'os', 'occsort', 'ip', 'interestprofilersf', 'eq', 'entrepreneurquiz']
  },
  {
    module: '', baseUrl: 'login',
    allowedRoutes: ['plpcontent', 'os', 'occsort', 'ip', 'interestprofilersf', 'eq', 'entrepreneurquiz']
  }

];


/** This variable is used for route configuration of lazy loaded modules and items used in each module.*/
export const routeObj = {
  plpPersonalInfo: {
    itemConfig: {
      url: './personalInfo',
      image: '/assets/images/enterpreneurial-icon.png',
      color: '#0a8f72',
      apiName: 'personal-info',
      section: 'PersonalInfo',
      icon: 'icon-personal-info',
    },
    routeConfig: {
      path: 'personalInfo',

      loadChildren: () =>
        new Promise((resolve) => {
          (require as any).ensure([], (requireVar) => {
            resolve(
              require('../../modules/PLP/shared/personal-info/personal-info.module')
                .PersonalInfoModule
            );
          });
        }),
    },
  },
  plpCareerGoals: {
    itemConfig: {
      url: './careerGoals',
      image: '/assets/images/enterpreneurial-icon.png',
      color: '#0a8f72',
      apiName: 'career-goals',
      section: 'CareerGoals',
      icon: 'icon-career-goals',
    },
    routeConfig: {
      path: 'careerGoals',
      loadChildren: () =>
        new Promise((resolve) => {
          (require as any).ensure([], (requireVar) => {
            resolve(
              require('../../modules/PLP/shared/career-goals/career-goals.module')
                .CareerGoalsModule
            );
          });
        }),
    },
  },
  plpEducationPlans: {
    itemConfig: {
      url: './educationPlans',
      image: '/assets/images/enterpreneurial-icon.png',
      color: '#0a8f72',
      apiName: 'education-plans',
      section: 'EducationPlans',
      icon: 'icon-education-plans',
    },
    routeConfig: {
      path: 'educationPlans',
      loadChildren: () =>
        new Promise((resolve) => {
          (require as any).ensure([], (requireVar) => {
            resolve(
              require('../../modules/PLP/shared/education-plans/education-plans.module')
                .EducationPlansModule
            );
          });
        }),
    },
  },
  plpActionPlan: {
    itemConfig: {
      url: './actionPlan',
      image: '/assets/images/enterpreneurial-icon.png',
      color: '#0a8f72',
      apiName: 'action-plan',
      section: 'ActionPlan',
      icon: 'icon-action-plan',
    },
    routeConfig: {
      path: 'actionPlan',
      loadChildren: () =>
        new Promise((resolve) => {
          (require as any).ensure([], (requireVar) => {
            resolve(
              require('../../modules/PLP/shared/action-plan-for-year/action-plan-for-year.module')
                .ActionPlansModule
            );
          });
        }),
    },
  },
  plpSortsAssessments: {
    itemConfig: {
      url: './careerAssessment',
      image: '/assets/images/enterpreneurial-icon.png',
      color: '#0a8f72',
      apiName: 'self-knowledge-career-assess',
      section: 'CareerAssessments',
      icon: 'icon-self-knowledge-career-assessment',
    },
    routeConfig: {
      path: 'careerAssessment',
      loadChildren: () =>
        new Promise((resolve) => {
          (require as any).ensure([], (requireVar) => {
            resolve(
              require('../../modules/PLP/shared/career-assessments/career-assessments.module')
                .CareerAssessmentsModule
            );
          });
        }),
    },
  },
  plpCareerClusters: {
    itemConfig: {
      url: './careerCluster',
      image: '/assets/images/enterpreneurial-icon.png',
      color: '#0a8f72',
      apiName: 'career-clusters-interest',
      section: 'CareerCluster',
      icon: 'icon-career-clusters-interest',
    },
    routeConfig: {
      path: 'careerCluster',
      loadChildren: () =>
        new Promise((resolve) => {
          (require as any).ensure([], (requireVar) => {
            resolve(
              require('../../modules/PLP/shared/career-cluster/career-cluster.module')
                .CareerClusterModule
            );
          });
        }),
    },
  },
  plpCommentsSign: {
    itemConfig: {
      url: './commentsSignature',
      image: '/assets/images/enterpreneurial-icon.png',
      color: '#0a8f72',
      apiName: 'comments-sign',
      section: 'CommentsAndSignature',
      icon: 'icon-comments-sign',
    },
    routeConfig: {
      path: 'commentsSignature',
      loadChildren: () =>
        new Promise((resolve) => {
          (require as any).ensure([], (requireVar) => {
            resolve(
              require('../../modules/PLP/shared/comments-and-signature/comments-and-signature.module')
                .CommentsAndSignatureModule
            );
          });
        }),
    },
  },
  //@todo remove
  cpCoursePlanner: {
    itemConfig: {
      url: './coursePlan',
      image: '/assets/images/couse-planner.png',
      color: '#0a8f72',
      apiName: 'course-plan',
      section: 'CoursePlan',
      icon: environment.fontIcons + 'course-planner_grey.svg',
    },
    routeConfig: {
      path: 'coursePlan',
      loadChildren: () =>
        import('../../modules/course-planner/course-planner.module').then(
          (m) => m.CoursePlannerModule
        ),
      /*new Promise(resolve => {
                                (require as any).ensure([], requireVar => {
                                        resolve(require('../../modules/PLP/shared/course-plan/course-plan.module').CoursePlanModule);
                                });
                        })*/
    },
  },
  plpEmploymentHistory: {
    itemConfig: {
      url: './empHistory',
      image: '/assets/images/enterpreneurial-icon.png',
      color: '#0a8f72',
      apiName: 'employment-historyWork',
      section: 'EmploymentHistory',
      icon: 'icon-employment-history-work',
    },

    routeConfig: {
      path: 'empHistory',
      loadChildren: () =>
        new Promise((resolve) => {
          (require as any).ensure([], (requireVar) => {
            resolve(
              require('../../modules/PLP/shared/employment-history/employment-history.module')
                .EmploymentHistoryModule
            );
          });
        }),
    },
  },
  plpExperientialLearning: {
    itemConfig: {
      url: './expLearning',
      image: '/assets/images/enterpreneurial-icon.png',
      color: '#0a8f72',
      apiName: 'experiential-learning',
      section: 'ExperientialLearning',
      icon: 'icon-experiential-learning',
    },
    routeConfig: {
      path: 'expLearning',
      loadChildren: () =>
        new Promise((resolve) => {
          (require as any).ensure([], (requireVar) => {
            resolve(
              require('../../modules/PLP/shared/experiential-learning/experiential-learning.module')
                .ExperientialLearningModule
            );
          });
        }),
    },
  },
  plpExtracurricularActivities: {
    itemConfig: {
      url: './extraActivities',
      image: '/assets/images/enterpreneurial-icon.png',
      color: '#0a8f72',
      apiName: 'extracurricular-activities',
      section: 'ExtraActivities',
      icon: 'icon-extracurricular-activities',
    },
    routeConfig: {
      path: 'extraActivities',
      loadChildren: () =>
        new Promise((resolve) => {
          (require as any).ensure([], (requireVar) => {
            resolve(
              require('../../modules/PLP/shared/extra-activities/extra-activities.module')
                .ExtraActivitiesModule
            );
          });
        }),
    },
  },
  plpGradRequirements: {
    itemConfig: {
      url: './gradRequirement',
      image: '/assets/images/.jpg',
      color: '#0a8f72',
      apiName: 'grad-requirement',
      section: 'GraduationRequirements',
      icon: 'icon-grad-requirement',
    },
    routeConfig: {
      path: 'gradRequirement',
      loadChildren: () =>
        new Promise((resolve) => {
          (require as any).ensure([], (requireVar) => {
            resolve(
              require('../../modules/PLP/shared/graduation-requirements/graduation-requirements.module')
                .GraduationRequirementsModule
            );
          });
        }),
    },
  },
  plpOccsAndClusters: {
    itemConfig: {
      url: './occCluster',
      image: '/assets/images/enterpreneurial-icon.png',
      color: '#0a8f72',
      apiName: 'occ-and-clusters-interest',
      section: 'OccAndCluster',
      icon: 'icon-occ-and-clusters-interest',
    },
    routeConfig: {
      path: 'occCluster',
      loadChildren: () =>
        new Promise((resolve) => {
          (require as any).ensure([], (requireVar) => {
            resolve(
              require('../../modules/PLP/shared/occ-and-cluster/occ-and-cluster.module')
                .OccAndClusterModule
            );
          });
        }),
    },
  },
  plpPostsecondarySchools: {
    itemConfig: {
      url: './schoolsOfInterest',
      image: '/assets/images/enterpreneurial-icon.png',
      color: '#0a8f72',
      apiName: 'postsecondary-schools',
      section: 'SchoolsOfInterest',
      icon: 'icon-postsecondary-schools',
    },
    routeConfig: {
      path: 'schoolsOfInterest',
      loadChildren: () =>
        new Promise((resolve) => {
          (require as any).ensure([], (requireVar) => {
            resolve(
              require('../../modules/PLP/shared/schools-of-interest/schools-of-interest.module')
                .SchoolsOfInterestModule
            );
          });
        }),
    },
  },
  plpProgramsOfStudy: {
    itemConfig: {
      url: './studyOfInterest',
      image: '/assets/images/enterpreneurial-icon.png',
      color: '#0a8f72',
      apiName: 'prog-of-study-of-interest',
      section: 'StudyOfInterest',
      icon: 'icon-prog-of-study-of-interest',
    },
    routeConfig: {
      path: 'studyOfInterest',
      loadChildren: () =>
        new Promise((resolve) => {
          (require as any).ensure([], (requireVar) => {
            resolve(
              require('../../modules/PLP/shared/study-of-interest/study-of-interest.module')
                .StudyOfInterestModule
            );
          });
        }),
    },
  },
  plpSupportNetwork: {
    itemConfig: {
      url: './supportNetwork',
      image: '/assets/images/.jpg',
      color: '#0a8f72',
      apiName: 'support-network',
      section: 'SupportNetwork',
      icon: 'icon-support-network',
    },
    routeConfig: {
      path: 'supportNetwork',
      loadChildren: () =>
        new Promise((resolve) => {
          (require as any).ensure([], (requireVar) => {
            resolve(
              require('../../modules/PLP/shared/support-network/support-network.module')
                .SupportNetworkModule
            );
          });
        }),
    },
  },
  plpTestScores: {
    itemConfig: {
      url: './testScores',
      image: '/assets/images/enterpreneurial-icon.png',
      color: '#0a8f72',
      apiName: 'test-scores',
      section: 'TestScores',
      icon: 'icon-test-scores',
    },
    routeConfig: {
      path: 'testScores',
      loadChildren: () =>
        new Promise((resolve) => {
          (require as any).ensure([], (requireVar) => {
            resolve(
              require('../../modules/PLP/shared/test-scores/test-scores.module')
                .TestScoresModule
            );
          });
        }),
    },
  },
  plpCommunityService: {
    itemConfig: {
      url: './volunteerCommunity',
      image: '/assets/images/enterpreneurial-icon.png',
      color: '#0a8f72',
      apiName: 'volun-comm-service',
      section: 'VolunteerCommunityService',
      icon: 'icon-volun-comm-service',
    },
    routeConfig: {
      path: 'volunteerCommunity',
      loadChildren: () =>
        new Promise((resolve) => {
          (require as any).ensure([], (requireVar) => {
            resolve(
              require('../../modules/PLP/shared/volunteer-community-service/volunteer-community-service.module')
                .VolunteerCommunityServiceModule
            );
          });
        }),
    },
  },
  sortEntQuiz: {
    itemConfig: {
      url: './entrepreneurQuiz/intro',
      image: environment.LandingImages + 'enterpreneurial-icon.png',
      color: '#0A7B6D',
      apiName: 'entrepreneurQuiz',
      section: 'entrepreneurQuiz',
      icon: environment.fontIcons + 'Eq_grey.svg',
      sprite: 'icon-enterpreneurial_icon-sprite',
    },
    routeConfig: {
      path: 'entrepreneurQuiz',
      loadChildren: () =>
        new Promise((resolve) => {
          (require as any).ensure([], (requireVar) => {
            resolve(
              require('../../modules/assessments/entrepreneur-quiz/entquiz.module')
                .EnterpreneurQuizModule
            );
          });
        }),
    },
  },
  sortShortIP: {
    itemConfig: {
      url: './interestProfilerSf/intro',
      image: environment.LandingImages + 'Interest-Profiler-icon.png',
      color: '#045978',
      apiName: 'interestProfilerSf',
      section: 'interestProfilerSf',
      icon: environment.fontIcons + '/Ip_grey.svg',
      sprite: 'icon-Interest_Profiler_icon-sprite',
    },
    routeConfig: {
      path: 'interestProfilerSf',
      loadChildren: () =>
        new Promise((resolve) => {
          (require as any).ensure([], (requireVar) => {
            resolve(
              require('../../modules/assessments/interest-profiler-sf/interestProfilerSf.module')
                .InterestProfilerSfModule
            );
          });
        }),
    },
  },
  sortMiniIP: {
    itemConfig: {
      url: './miniInterestProfiler/intro',
      image: environment.LandingImages + 'interest-profiler_mini-icon.png',
      color: '#3f51b5',
      apiName: 'miniInterestProfiler',
      section: 'miniInterestProfiler',
      icon: environment.fontIcons + 'miniIp_grey.svg',
      sprite: 'icon-interest_profiler_mini_icon-sprite',
    },
    routeConfig: {
      path: 'miniInterestProfiler',
      loadChildren: () =>
        new Promise((resolve) => {
          (require as any).ensure([], (requireVar) => {
            resolve(
              require('../../modules/assessments/mini-interest-profiler/mini-interest-profiler.module')
                .MiniInterestProfilerModule
            );
          });
        }),
    },
  },
  sortOccSort: {
    itemConfig: {
      url: './occSort/intro',
      image: environment.LandingImages + 'Occupation-Sort-icon.png',
      color: '#117779',
      apiName: 'occSort',
      section: 'occSort',
      icon: environment.fontIcons + 'Os_grey.svg',
      sprite: 'icon-Occupation_Sort_icon-sprite',
    },
    routeConfig: {
      path: 'occSort',
      loadChildren: () =>
        new Promise((resolve) => {
          (require as any).ensure([], (requireVar) => {
            resolve(
              require('../../modules/assessments/occ-sort/occsort.module')
                .OccSortModule
            );
          });
        }),
    },
  },
  sortCCIJr: {
    itemConfig: {
      url: './cciJr/intro',
      image: environment.LandingImages + 'cci-image.png',
      color: '#B9520B',
      apiName: 'cciJr',
      section: 'cciJr',
      icon: environment.fontIcons + 'CciJr_grey.svg',
      sprite: 'icon-cci_image-sprite',
    },
    routeConfig: {
      path: 'cciJr',
      loadChildren: () =>
        new Promise((resolve) => {
          (require as any).ensure([], (requireVar) => {
            resolve(
              require('../../modules/assessments/career-cluster-inventory/career-cluster.module')
                .CCIModule
            );
          });
        }),
    },
  },
  sortCCIQuick: {
    itemConfig: {
      url: './cciQuick/intro',
      image: environment.LandingImages + 'baby_CCI.png',
      color: '#4268CC',
      apiName: 'cciQuick',
      section: 'cciQuick',
      icon: environment.fontIcons + 'Cci_Quick_pic_grey.svg',
      sprite: 'icon-baby_CCI-sprite',
    },
    routeConfig: {
      path: 'cciQuick',
      loadChildren: () =>
        new Promise((resolve) => {
          (require as any).ensure([], (requireVar) => {
            resolve(
              require('../../modules/assessments/cci-quick/cci-quick.module')
                .CCIQuickModule
            );
          });
        }),
    },
  },
  sortCCIAdult: {
    itemConfig: {
      url: './cciAdult/intro',
      image: environment.LandingImages + 'cciAdult-landing.png',
      color: '#D6119D',
      apiName: 'cciAdult',
      section: 'cciAdult',
      icon: environment.fontIcons + 'CciAdult_grey.svg',
      sprite: 'icon-cciAdult_landing-sprite',
    },
    routeConfig: {
      path: 'cciAdult',
      loadChildren: () =>
        new Promise((resolve) => {
          (require as any).ensure([], (requireVar) => {
            resolve(
              require('../../modules/assessments/career-cluster-inventory/career-cluster.module')
                .CCIModule
            );
          });
        }),
    },
  },
  sortLearnStyle: {
    itemConfig: {
      url: './lssAsessment/intro',
      image: environment.LandingImages + 'lss-image.png',
      color: '#0277bd',
      apiName: 'lssAsessment',
      section: 'lssAsessment',
      icon: environment.fontIcons + 'Lss_grey.svg',
      sprite: 'icon-lss_image-sprite',
    },
    routeConfig: {
      path: 'lssAsessment',
      loadChildren: () =>
        new Promise((resolve) => {
          (require as any).ensure([], (requireVar) => {
            resolve(
              require('../../modules/assessments/learning-style-survey/learning-style.module')
                .LSSModule
            );
          });
        }),
    },
  },
  sortWES: {
    itemConfig: {
      url: './wesAsessment/intro',
      image: environment.LandingImages + 'wes-image.png',
      color: '#C92756',
      apiName: 'wesAsessment',
      section: 'wesAsessment',
      icon: environment.fontIcons + 'WesAdult_grey.svg',
      sprite: 'icon-wes_image-sprite',
    },
    routeConfig: {
      path: 'wesAsessment',
      loadChildren: () =>
        new Promise((resolve) => {
          (require as any).ensure([], (requireVar) => {
            resolve(
              require('../../modules/assessments/workplace-employability-skills/workplace-employability.module')
                .WESModule
            );
          });
        }),
    },
  },
  sortWESJr: {
    itemConfig: {
      url: './wesJrAsessment/intro',
      image: environment.LandingImages + 'wesjr-card-icon.png',
      color: '#AF5480',
      apiName: 'wesJrAsessment',
      section: 'wesJrAsessment',
      icon: environment.fontIcons + 'WesJr_grey.svg',
      sprite: 'icon-wesjr_card_icon-sprite',
    },
    routeConfig: {
      path: 'wesJrAsessment',
      loadChildren: () =>
        new Promise((resolve) => {
          (require as any).ensure([], (requireVar) => {
            resolve(
              require('../../modules/assessments/wesJr/workplace-employability-junior.module')
                .WESJrModule
            );
          });
        }),
    },
  },
  sortWIL: {
    itemConfig: {
      url: './wilAsessment/intro',
      image: environment.LandingImages + 'wil-image.png',
      color: '#a80067',
      apiName: 'wilAsessment',
      section: 'wilAsessment',
      icon: environment.fontIcons + 'Wil_grey.svg',
      sprite: 'icon-wil_image-sprite',
    },
    routeConfig: {
      path: 'wilAsessment',
      loadChildren: () =>
        new Promise((resolve) => {
          (require as any).ensure([], (requireVar) => {
            resolve(
              require('../../modules/assessments/work-importance-locator/work-importance.module')
                .WILModule
            );
          });
        }),
    },
  },

  sortIDEAS: {
    itemConfig: {
      url: './ideasAssessment/intro',
      image: environment.LandingImages + 'ideas-image.png',
      color: '#AB47BC',
      apiName: 'ideasAssessment',
      section: 'ideasAssessment',
      icon: environment.fontIcons + 'Ideas_grey.svg',
      sprite: 'icon-ideas_image-sprite',
    },
    routeConfig: {
      path: 'ideasAssessment',
      loadChildren: () =>
        new Promise((resolve) => {
          (require as any).ensure([], (requireVar) => {
            resolve(
              require('../../modules/assessments/ideas/ideas-module')
                .IdeasModule
            );
          });
        }),
    },
  },
  sortRealityCheck: {
    itemConfig: {
      url: './reality-check/intro',
      image: environment.LandingImages + 'rc-icon.png',
      color: '#637601',
      apiName: 'rc-icon',
      section: 'rc-icon',
      icon: environment.fontIcons + 'reality-check_grey.svg',
      sprite: 'icon-rc_icon-sprite ',
    },
    routeConfig: {
      path: 'reality-check',
      loadChildren: () =>
        new Promise((resolve) => {
          (require as any).ensure([], (requireVar) => {
            resolve(
              require('../../modules/assessments/reality-check/reality-check.module')
                .RealityCheckModule
            );
          });
        }),
    },
  },
  fileOcc: {
    itemConfig: {
      url: './careers-details/occIndex',
      image: environment.LandingImages + 'occcareers.png',
      color: '#015658',
      apiName: 'occcareers',
      section: 'occcareers',
      icon: environment.fontIcons + 'careers_grey.svg',
      sprite: 'icon-occresize-sprite',
    },
    routeConfig: {
      path: 'careers-details',
      loadChildren: () =>
        new Promise((resolve) => {
          (require as any).ensure([], (requireVar) => {
            resolve(
              require('../../modules/careers-details/occ-details/occ-details-module')
                .OccDetailModule
            );
          });
        }),
    },
  },
  fileOccJr: {
    itemConfig: {
      url: './careersJr/careerJrIndex',
      image: environment.LandingImages + 'favorite-cluster.png',
      color: '#1198a7',
      apiName: 'occjrcareers',
      section: 'occjrcareers',
      icon: environment.fontIcons + 'jrCareers_grey.svg',
      sprite: 'icon-occresize-sprite',
    },
    routeConfig: {
      path: 'careersJr',
      loadChildren: () =>
        new Promise((resolve) => {
          (require as any).ensure([], (requireVar) => {
            resolve(
              require('../../modules/careers-details/careersJr/careersJr-details-module')
                .CareersJrDetailModule
            );
          });
        }),
    },
  },
  fileMil: {
    itemConfig: {
      url: './military-details/militaryCareerIndex',
      image: environment.LandingImages + 'military-landing.png',
      color: '#75792F',
      apiName: 'militarycareer',
      section: 'militarycareer',
      icon: environment.fontIcons + 'Military_grey.svg',
      sprite: 'icon-military_header_icon-sprite',
    },
    routeConfig: {
      path: 'military-details',
      loadChildren: () =>
        new Promise((resolve) => {
          (require as any).ensure([], (requireVar) => {
            resolve(
              require('../../modules/careers-details/military-career/military-career.module')
                .MilitaryCareerModule
            );
          });
        }),
    },
  },
  fileProg: {
    itemConfig: {
      url: './progsdetails/progsIndex',
      image: environment.LandingImages + 'progs-landing.png',
      color: '#ba3c9f',
      apiName: 'progs-landing',
      section: 'progs-landing',
      icon: environment.fontIcons + 'progs_grey.svg',
      sprite: 'icon-progsresize-sprite',
    },
    routeConfig: {
      path: 'progsdetails',
      loadChildren: () =>
        new Promise((resolve) => {
          (require as any).ensure([], (requireVar) => {
            resolve(
              require('../../modules/education-details/programs-study/progs-details-module')
                .ProgsDetailModule
            );
          });
        }),
    },
  },
  fileNSch: {
    itemConfig: {
      url: './schoolsdetails/schoolsIndex',
      image: environment.LandingImages + 'schools-landing.png',
      color: '#ae404b',
      apiName: 'schools-landing',
      section: 'schools-landing',
      icon: environment.fontIcons + 'schools_grey.svg',
      sprite: 'icon-schools-sprite',
    },
    routeConfig: {
      path: 'schoolsdetails',
      loadChildren: () =>
        new Promise((resolve) => {
          (require as any).ensure([], (requireVar) => {
            resolve(
              require('../../modules/education-details/schools/schools-details-modules')
                .SchoolsDetailModule
            );
          });
        }),
    },
  },
  fileAid: {
    itemConfig: {
      url: './financialdetails/financialIndex',
      image: environment.LandingImages + 'financial-aid-landing.png',
      color: '#89404B',
      apiName: 'financialdetails',
      section: 'financialdetails',
      icon: environment.fontIcons + 'financial-aid_grey.svg',
      sprite: 'icon-financial_aid_landing-sprite',
    },
    routeConfig: {
      path: 'financialdetails',
      loadChildren: () =>
        new Promise((resolve) => {
          (require as any).ensure([], (requireVar) => {
            resolve(
              require('../../modules/education-details/financial-aid/financial-details-module')
                .FinancialDetailModule
            );
          });
        }),
    },
  },
  customCustomModule: {
    itemConfig: {
      url: './dynamicwidget/custom-widget',
      image: '/assets/images/ideas-image.png',
      color: '#A73853',
      apiName: 'dynamicwidget',
      section: 'dynamicwidget',
      icon: environment.fontIcons + 'custom-dynamic-plp_grey.svg',
    },
    routeConfig: {
      path: 'dynamicwidget',
      loadChildren: () =>
        new Promise((resolve) => {
          (require as any).ensure([], (requireVar) => {
            resolve(
              require('../../modules/CustomWidget/content-wizard/content-wizard.module')
                .ContentWizardModule
            );
          });
        }),
    },
  },
  customCustomReflections: {
    itemConfig: {
      url: './dynamicwidget/custom-widget',
      image: '/assets/images/ideas-image.png',
      color: '#e65f70',
      apiName: 'dynamicwidget',
      section: 'dynamicwidget',
      icon: environment.fontIcons + 'custom-dynamic-plp_grey.svg',
    },
    routeConfig: {
      path: 'dynamicwidget',
      loadChildren: () =>
        new Promise((resolve) => {
          (require as any).ensure([], (requireVar) => {
            resolve(
              require('../../modules/CustomWidget/content-wizard/content-wizard.module')
                .ContentWizardModule
            );
          });
        }),
    },
  },
  resumeResume: {
    itemConfig: {
      url: './resumebuilder/resume-module/resume-detail',
      startUrl: 'resumebuilder/resume-module/',
      image: environment.AssetsUrl + 'resume-task-icon.png',
      color: '#A85E13',
      apiName: 'resumebuilder',
      section: 'resumebuilder',
      icon: environment.fontIcons + 'resume-builder_grey.svg',
    },
    routeConfig: {
      path: 'resumebuilder',
      loadChildren: () =>
        import(
          '../../modules/resume-builder/resume-builder.module'
        ).then((m) => m.ResumeBuilderModule),
    },
  },
  resumeCoverLetter: {
    itemConfig: {
      url: './resumebuilder/resume-module/cover-detail',
      image: environment.AssetsUrl + 'cover-letter-task-icon.png',
      color: '#BF5101',
      apiName: 'resumebuilder',
      section: 'resumebuilder',
      icon: environment.fontIcons + 'cover-letter_grey.svg',
    },
    routeConfig: {
      path: 'resumebuilder',
      loadChildren: () =>
        import(
          '../../modules/resume-builder/resume-builder.module'
        ).then((m) => m.ResumeBuilderModule),
    },
  },
  formCustomModule: {
    itemConfig: {
      url: './dynamicform/custom-form',
      image: '/assets/images/ideas-image.png',
      color: '#e65f70',
      apiName: 'dynamicwidget',
      section: 'dynamicwidget',
      icon: environment.fontIcons + 'custom-dynamic-plp_grey.svg',
    },
    routeConfig: {
      path: 'dynamicform',
      loadChildren: () =>
        new Promise((resolve) => {
          (require as any).ensure([], (requireVar) => {
            resolve(
              require('../../modules/custom-form/custom-form.module')
                .CustomFormModule
            );
          });
        }),
    },
  },
  printCustomModule: {
    itemConfig: {
      // include :itemID placeholder so callers can navigate to a specific item
      url: './dynamicprint/:itemID/custom-print',
      image: '/assets/images/ideas-image.png',
      color: '#e65f70',
      apiName: 'dynamicprint',
      section: 'dynamicprint',
      icon: environment.fontIcons + 'custom-print_grey.svg',
    },
    routeConfig: {
      path: 'dynamicprint',
      loadChildren: () =>
        new Promise((resolve) => {
          (require as any).ensure([], (requireVar) => {
            resolve(
              require('../../modules/custom-print/custom-print.module')
                .CustomPrintModule
            );
          });
        }),
    },
  },
  cpCoursePlan: {
    itemConfig: {
      url: './coursePlan',
      image: '/assets/images/enterpreneurial-icon.png',
      color: '#0a8f72',
      apiName: 'course-plan',
      section: 'CoursePlan',
      icon: 'icon-course-plan',
    },
    routeConfig: {
      path: 'coursePlan',
      loadChildren: () =>
        import('../../modules/course-planner/course-planner.module').then(
          (m) => m.CoursePlannerModule
        ),
    },
  },
  url: {
    itemConfig: {
      url: '',
      image: '',
      color: '',
      apiName: '',
      section: '',
      icon: '',
    },
  },
  /**Dependable strengths tile  */
  sortDependableStrengths: {
    itemConfig: {
      url: './dependable-strengths/ds-home',
      image: environment.LandingImages + 'DS-image.png',
      color: '#6fa301',
      apiName: 'dependable-strengths',
      section: 'dependable-strengths',
      icon: environment.fontIcons + 'reality-check_grey.svg',
      sprite: 'dependable-strengths',
    },
    routeConfig: {
      path: 'dependable-strengths',
      loadChildren: () =>
        new Promise((resolve) => {
          (require as any).ensure([], (requireVar) => {
            resolve(
              require('../../modules/assessments/dependable-strengths/dependable-strengths.module')
                .DependableStrengthsModule
            );
          });
        }),
    },
  },

  /**petersons Testprep */
  sortAcadTests1: {
    itemConfig: {
      url: './practice-test/home/0',
      image: 'https://materials.intocareers.org/360-images/logo-pcom.png',
      color: '#3d3f47',
      apiName: 'College Entrance',
      section: 'Practice Test',
      icon: environment.fontIcons + 'reality-check_grey.svg',
      sprite: 'Testprep',
    },
    routeConfig: {
      path: 'practice-test',
      loadChildren: () =>
        new Promise((resolve) => {
          (require as any).ensure([], (requireVar) => {
            resolve(
              require('../../modules/practice-test/practice-test.module')
                .PracticeTestModule
            );
          });
        }),
    },
  },
  sortAcadTests2: {
    itemConfig: {
      url: './practice-test/home/1',
      image: 'https://materials.intocareers.org/360-images/logo-pcom.png',
      color: '#3d3f47',
      apiName: 'Advanced Academic',
      section: 'Practice Test',
      icon: environment.fontIcons + 'reality-check_grey.svg',
      sprite: 'Testprep',
    },
    routeConfig: {
      path: 'practice-test',
      loadChildren: () =>
        new Promise((resolve) => {
          (require as any).ensure([], (requireVar) => {
            resolve(
              require('../../modules/practice-test/practice-test.module')
                .PracticeTestModule
            );
          });
        }),
    },
  },
  sortCivilTests: {
    itemConfig: {
      url: './practice-test/home/2',
      image: 'https://materials.intocareers.org/360-images/logo-pcom.png',
      color: '#3d3f47',
      apiName: 'Civil Service',
      section: 'Practice Test',
      icon: environment.fontIcons + 'reality-check_grey.svg',
      sprite: 'Testprep',
    },
    routeConfig: {
      path: 'practice-test',
      loadChildren: () =>
        new Promise((resolve) => {
          (require as any).ensure([], (requireVar) => {
            resolve(
              require('../../modules/practice-test/practice-test.module')
                .PracticeTestModule
            );
          });
        }),
    },
  },
  sortCPST: {
    itemConfig: {
      url: './practice-test/home/3',
      image: 'https://materials.intocareers.org/360-images/logo-pcom.png',
      color: '#3d3f47',
      apiName: 'College Placement',
      section: 'Practice Test',
      icon: environment.fontIcons + 'reality-check_grey.svg',
      sprite: 'Testprep',
    },
    routeConfig: {
      path: 'practice-test',
      loadChildren: () =>
        new Promise((resolve) => {
          (require as any).ensure([], (requireVar) => {
            resolve(
              require('../../modules/practice-test/practice-test.module')
                .PracticeTestModule
            );
          });
        }),
    },
  },
  /**job interviews */
  fileJS: {
    itemConfig: {
      url: './job-interviews/home',
      image: 'https://images.intocareers.org/landing/interviews.png ',
      color: '#886F00',
      apiName: 'Job interviews',
      section: 'Job Interviews',
      // icon: environment.fontIcons + 'reality-check_grey.svg',
      sprite: 'JobInterviews',
    },
    routeConfig: {
      path: 'job-interviews',
      loadChildren: () =>
        new Promise((resolve) => {
          (require as any).ensure([], (requireVar) => {
            resolve(
              require('../../modules/job-interviews/job-interviews.module')
                .JobInterviewsModule
            );
          });
        }),
    },
  },

  /**Skills Explorer Self-surveys */
  sortSKILLS: {
    itemConfig: {
      url: './skills/intro',
      image: environment.LandingImages + 'ideas-image.png',
      color: '#AB47BC',
      apiName: 'skills',
      section: 'skills',
      icon: environment.fontIcons + 'Ideas_grey.svg',
      sprite: 'icon-ideas_image-sprite',
    },
    routeConfig: {
      path: 'skills',
      loadChildren: () =>
        new Promise((resolve) => {
          (require as any).ensure([], (requireVar) => {
            resolve(
              require('../../modules/assessments/skills/skills.module')
                .SkillsModule
            );
          });
        }),
    },
  },
};

//printICAP to the existing printCustomModule to combine both entries
(routeObj as any).printICAP = routeObj.printCustomModule;
(routeObj as any).printICDP = routeObj.printCustomModule;
(routeObj as any).printIMP = routeObj.printCustomModule;

export const langData = {};
